import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { error: String, confirm: String }

  // kontroler wisi na wrapperze tabeli (jedna instancja), per-wierszowy URL przychodzi
  // jako action param z selecta (data-plan-select-url-param)
  update(event) {
    const select = event.target
    const newPlan = select.value
    const previousPlan = select.dataset.currentPlan
    const revert = () => { select.value = previousPlan }

    // potwierdzenie przed zmiana planu - jesli anuluje to requeset nie leci
    if (this.hasConfirmValue && !window.confirm(this.confirmValue)) {
      revert()
      return
    }

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    fetch(event.params.url, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-CSRF-Token": csrfToken
      },
      body: JSON.stringify({ plan: newPlan })
    }).then(res => {
      if (res.ok) {
        select.dataset.currentPlan = newPlan
        return
      }

      // błąd walidacji/serwera - cofnij wybor i pokaz generyczny komunikat
      revert()
      return res.json()
        .then(data => this.showError(data.message || this.errorValue))
        .catch(() => this.showError(this.errorValue))
    }).catch(() => {
      // bład sieci - brak odpowiedzi serwera
      revert()
      this.showError(this.errorValue)
    })
  }

  showError(message) {
    // jGrowl to projektowy toast (jak w dropdown_status), alert to fallback gdy niedostepny
    try { $.jGrowl(message) } catch (e) { alert(message) }
  }
}
